<template>
  <info-header-card
    :icon="customer_contact.icon()"
    :header="header"
    :rows="rows"
  >
    <template v-if="!is_form" #header>
      <b-button-group class="float-right my-n1">
        <b-button
          v-show="checkPermission('edit customer contact')"
          size="sm"
          :to="editLink"
        >
          <i class="fal fa-pencil" />
        </b-button>
        <b-button
          v-show="checkPermission('edit customer contact')"
          size="sm"
          @click="deleteContact"
        >
          <i class="fal fa-trash" />
        </b-button>
      </b-button-group>
    </template>
  </info-header-card>
</template>

<script>
import CustomerContactModel from "@/models/crm/CustomerContactModel";
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "CustomerContactCard",
  components: {
    InfoHeaderCard,
  },
  props: {
    customer_contact: {
      type: Object,
      default: () => new CustomerContactModel(),
    },
    is_form: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    editLink() {
      const { customer_id, id } = this.customer_contact;

      return `/customer/${customer_id}/contacts/${id}/edit`;
    },
    header() {
      const { first_name, last_name } = this.customer_contact;

      return first_name || last_name ? `${first_name} ${last_name ? last_name : ''}` : "TBD";
    },
    rows() {
      const { phone, email, role, fax } = this.customer_contact;
      return [
        {
          label: "Phone",
          value: phone ? phone : "TBD",
        },
        {
          label: "Email",
          value: email ? email : "TBD",
        },
        {
          label: "Role",
          value: role ? role : "TBD",
        },
        {
          label: "Fax",
          value: fax ? fax : "TBD",
        },
      ];
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    deleteContact() {
      return this.deleteModel(
        this.customer_contact,
        this.customer_contact.first_name
      );
    },
  },
};
</script>
